{
  "about.contact": "सम्पर्क:",
  "about.default_locale": "पूर्वनिर्धारित",
  "about.disclaimer": "Mastodon नि:शुल्क, खुला स्रोत सफ्टवेयर, र Mastodon gGmbH को ट्रेडमार्क हो।",
  "about.domain_blocks.no_reason_available": "कारण उपलब्ध छैन",
  "about.domain_blocks.preamble": "Mastodon ले तपाइँलाई सामान्यतया फेडिभर्समा कुनै पनि अन्य सर्भरका सामग्री हेर्न र प्रयोगकर्ताहरूसँग अन्तरक्रिया गर्न दिन्छ। यी अपवादहरू हुन् जुन यस विशेष सर्भरमा बनाइएका छन्।",
  "about.domain_blocks.silenced.title": "सीमित",
  "about.domain_blocks.suspended.explanation": "यस सर्भरबाट कुनै पनि डेटा प्रशोधन, भण्डारण वा आदानप्रदान गरिने छैन, जसले यस सर्भरका प्रयोगकर्ताहरूसँग कुनै पनि अन्तरक्रिया वा सञ्चारलाई असम्भव बनाउँछ।",
  "about.domain_blocks.suspended.title": "निलम्बित",
  "about.language_label": "भाषा",
  "about.not_available": "यो जानकारी यस सर्भरमा उपलब्ध गराइएको छैन।",
  "about.powered_by": "{mastodon} द्वारा संचालित विकेन्द्रीकृत सामाजिक मिडिया",
  "about.rules": "सर्भर नियमहरू",
  "account.add_or_remove_from_list": "सूचीबाट थप्नुहोस् वा हटाउनुहोस्",
  "account.badges.bot": "स्वचालित",
  "account.badges.group": "समूह",
  "account.block": "@{name} लाई ब्लक गर्नुहोस्",
  "account.block_domain": "{domain} डोमेनलाई ब्लक गर्नुहोस्",
  "account.block_short": "ब्लक",
  "account.blocked": "ब्लक गरिएको",
  "account.cancel_follow_request": "फलो अनुरोध रद्द गर्नुहोस",
  "account.copy": "प्रोफाइलको लिङ्क प्रतिलिपि गर्नुहोस्",
  "account.direct": "@{name} लाई निजी रूपमा उल्लेख गर्नुहोस्",
  "account.disable_notifications": "@{name} ले पोस्ट गर्दा मलाई सूचित नगर्नुहोस्",
  "account.edit_profile": "प्रोफाइल सम्पादन गर्नुहोस्",
  "account.enable_notifications": "@{name} ले पोस्ट गर्दा मलाई सूचित गर्नुहोस्",
  "account.endorse": "प्रोफाइलमा फिचर गर्नुहोस्",
  "account.featured": "फिचर गरिएको",
  "account.featured.accounts": "प्रोफाइलहरू",
  "account.follow": "फलो गर्नुहोस",
  "account.follow_back": "फलो ब्याक गर्नुहोस्",
  "account.followers": "फलोअरहरु",
  "account.followers.empty": "यस प्रयोगकर्तालाई अहिलेसम्म कसैले फलो गरेको छैन।",
  "account.followers_counter": "{count, plural, one {{counter} फलोअर} other {{counter} फलोअरहरू}}",
  "account.following": "फलो गर्दै",
  "account.following_counter": "{count, plural, one {{counter} फलो गर्दै} other {{counter} फलो गर्दै}}",
  "account.follows.empty": "यो प्रयोगकर्ताले अहिलेसम्म कसैलाई फलो गरेको छैन।",
  "account.follows_you": "तपाईलाई फलो गर्नुहुन्छ",
  "account.go_to_profile": "प्रोफाइलमा जानुहोस्",
  "account.hide_reblogs": "@{name} को बूस्टहरू लुकाउनुहोस्",
  "account.in_memoriam": "सम्झनामा।",
  "account.link_verified_on": "यस लिङ्कको स्वामित्व {date} मा जाँच गरिएको थियो",
  "account.media": "मिडिया",
  "account.mention": "@{name} लाई उल्लेख गर्नुहोस्",
  "account.mute": "@{name}लाई म्यूट गर्नुहोस्",
  "account.mute_notifications_short": "सूचनाहरू म्यूट गर्नुहोस्",
  "account.mute_short": "म्युट",
  "account.muted": "म्युट गरिएको",
  "account.mutual": "तपाईंहरु एकअर्कालाई फलो गर्नुहुन्छ",
  "account.no_bio": "कुनै विवरण प्रदान गरिएको छैन।",
  "account.posts": "पोस्टहरू",
  "account.remove_from_followers": "{name}लाई फलोअरहरूबाट हटाउनुहोस्",
  "account.report": "@{name}लाई रिपोर्ट गर्नुहोस्",
  "account.requested_follow": "{name} ले तपाईंलाई फलो गर्न अनुरोध गर्नुभएको छ",
  "account.share": "@{name} को प्रोफाइल सेयर गर्नुहोस्",
  "account.show_reblogs": "@{name} को बूस्टहरू देखाउनुहोस्",
  "account.statuses_counter": "{count, plural, one {{counter} पोस्ट} other {{counter} पोस्टहरू}}",
  "account.unblock": "@{name} लाई अनब्लक गर्नुहोस्",
  "account.unblock_domain": "{domain} डोमेनलाई अनब्लक गर्नुहोस्",
  "account.unblock_domain_short": "अनब्लक गर्नुहोस्",
  "account.unblock_short": "अनब्लक गर्नुहोस्",
  "account.unendorse": "प्रोफाइलमा फिचर नगर्नुहोस्",
  "account.unfollow": "अनफलो गर्नुहोस्",
  "account.unmute": "@{name}लाई अनम्युट गर्नुहोस्",
  "account.unmute_notifications_short": "सूचनाहरू अनम्युट गर्नुहोस्",
  "account.unmute_short": "अनम्यूट गर्नुहोस्",
  "account_note.placeholder": "नोट लेख्न क्लिक गर्नुहोस्",
  "admin.dashboard.retention.average": "औसत",
  "admin.dashboard.retention.cohort_size": "नयाँ प्रयोगकर्ताहरू",
  "alert.rate_limited.message": "कृपया {retry_time, time, medium} पछि पुन: प्रयास गर्नुहोस्।",
  "alert.unexpected.message": "एउटा अनपेक्षित त्रुटि भयो।",
  "alt_text_modal.cancel": "रद्द गर्नुहोस्",
  "announcement.announcement": "घोषणा",
  "annual_report.summary.new_posts.new_posts": "नयाँ पोस्टहरू",
  "block_modal.remote_users_caveat": "हामी सर्भर {domain} लाई तपाईंको निर्णयको सम्मान गर्न सोध्नेछौं। तर, हामी अनुपालनको ग्यारेन्टी दिन सक्दैनौं किनभने केही सर्भरहरूले ब्लकहरू फरक रूपमा ह्यान्डल गर्न सक्छन्। सार्वजनिक पोस्टहरू लग इन नभएका प्रयोगकर्ताहरूले देख्न सक्छन्।",
  "block_modal.show_less": "कम देखाउनुहोस्",
  "block_modal.show_more": "थप देखाउनुहोस्",
  "block_modal.they_will_know": "उनीहरूले उनीहरू ब्लक गरिएको देख्न सक्छन्।",
  "block_modal.title": "प्रयोगकर्तालाई ब्लक गर्ने?",
  "boost_modal.reblog": "पोस्ट बुस्ट गर्ने?",
  "boost_modal.undo_reblog": "पोस्ट अनबुस्ट गर्ने?",
  "bundle_column_error.copy_stacktrace": "त्रुटि रिपोर्ट प्रतिलिपि गर्नुहोस्",
  "bundle_column_error.network.title": "नेटवर्क त्रुटि",
  "bundle_column_error.retry": "पुन: प्रयास गर्नुहोस्",
  "bundle_column_error.routing.title": "४०४",
  "bundle_modal_error.close": "बन्द गर्नुहोस्",
  "bundle_modal_error.retry": "Try again",
  "closed_registrations.other_server_instructions": "Mastodon विकेन्द्रीकृत भएकोले, तपाइँ अर्को सर्भरमा खाता खोल्न सक्नुहुन्छ र पनि यो सर्भरसँग अन्तरक्रिया गर्न सक्नुहुन्छ।",
  "closed_registrations_modal.description": "हाल {domain} मा खाता सिर्जना गर्न सम्भव छैन, तर कृपया ध्यान राख्नुहोस् कि तपाईंले Mastodon प्रयोग गर्नको लागि {domain} मा नै खाता खोल्न आवश्यक छैन।",
  "closed_registrations_modal.find_another_server": "अर्को सर्भर खोज्नुहोस्",
  "closed_registrations_modal.title": "Mastodon मा साइन अप गर्दै",
  "column.blocks": "ब्लक गरिएको प्रयोगकर्ताहरु",
  "column.bookmarks": "बुकमार्कहरू",
  "column.create_list": "सूची बनाउनुहोस्",
  "column.direct": "निजी उल्लेखहरू",
  "column.directory": "प्रोफाइल ब्राउज गर्नुहोस्",
  "column.domain_blocks": "ब्लक गरिएको डोमेन",
  "column.edit_list": "सूची सम्पादन गर्नुहोस्",
  "column.follow_requests": "फलो अनुरोधहरू",
  "column.home": "गृहपृष्ठ",
  "column.lists": "सूचीहरू",
  "column.mutes": "म्यूट गरिएका प्रयोगकर्ताहरू",
  "column.notifications": "सूचनाहरू",
  "column.pins": "पिन गरिएका पोस्टहरू",
  "column_header.hide_settings": "सेटिङ्हरू लुकाउनुहोस्",
  "column_header.pin": "पिन गर्नुहोस्",
  "column_header.unpin": "अनपिन गर्नुहोस्",
  "column_search.cancel": "रद्द गर्नुहोस्",
  "community.column_settings.media_only": "मिडिया मात्र",
  "compose.language.change": "भाषा परिवर्तन गर्नुहोस्",
  "compose.language.search": "भाषाहरू खोज्नुहोस्...",
  "compose.published.body": "पोस्ट प्रकाशित भयो।",
  "compose.published.open": "खोल्नुहोस्",
  "compose.saved.body": "पोस्ट सेभ गरियो।",
  "compose_form.direct_message_warning_learn_more": "थप जान्नुहोस्",
  "compose_form.placeholder": "तपाईको मनमा के छ?",
  "compose_form.publish": "पोस्ट गर्नुहोस्",
  "compose_form.reply": "जवाफ दिनुहोस्",
  "compose_form.save_changes": "अपडेट गर्नुहोस्",
  "confirmation_modal.cancel": "रद्द गर्नुहोस्",
  "confirmations.block.confirm": "ब्लक गर्नुहोस्",
  "confirmations.delete.message": "के तपाइँ पक्का हुनुहुन्छ कि तपाईं यो पोष्ट मेटाउन चाहनुहुन्छ?",
  "confirmations.delete.title": "पोस्ट मेटाउने?",
  "confirmations.delete_list.message": "के तपाइँ पक्का हुनुहुन्छ कि तपाईं यो सूची स्थायी रूपमा मेटाउन चाहनुहुन्छ?",
  "confirmations.delete_list.title": "सूची मेटाउने?",
  "confirmations.follow_to_list.confirm": "फलो गर्नुहोस र सूचीमा थप्नुहोस्",
  "confirmations.follow_to_list.message": "सूचीमा {name}लाई थप्नको लागि तपाईंले तिनीहरूलाई फलो गरेको हुनुपर्छ।",
  "confirmations.follow_to_list.title": "प्रयोगकर्तालाई फलो गर्ने?",
  "confirmations.logout.confirm": "लग आउट",
  "confirmations.logout.message": "के तपाइँ पक्का हुनुहुन्छ कि तपाइँ लाई लग आउट गर्न चाहनुहुन्छ?",
  "confirmations.logout.title": "लग आउट गर्ने?",
  "confirmations.mute.confirm": "म्यूट गर्नुहोस्",
  "confirmations.redraft.confirm": "मेटाएर पुन: ड्राफ्ट गर्नुहोस्",
  "confirmations.redraft.title": "पोस्ट मेटाएर पुन: ड्राफ्ट गर्ने?",
  "confirmations.unfollow.confirm": "अनफलो गर्नुहोस्",
  "disabled_account_banner.account_settings": "खाता सेटिङहरू",
  "empty_column.direct": "तपाईंले अहिलेसम्म कुनै पनि प्राइवेट उल्लेखहरू प्राप्त गर्नुभएको छैन। तपाईंले कुनै प्राप्त गरेपछि त्यो यहाँ देखिनेछ।",
  "empty_column.follow_requests": "तपाईंले अहिलेसम्म कुनै पनि फलो अनुरोधहरू प्राप्त गर्नुभएको छैन। तपाईंले कुनै प्राप्त गरेपछि त्यो यहाँ देखिनेछ।",
  "empty_column.followed_tags": "तपाईंले अहिलेसम्म कुनै पनि ह्यासट्यागहरू फलो गर्नुभएको छैन। तपाईंले ह्यासट्याग फलो गरेपछि तिनीहरू यहाँ देखिनेछन्।",
  "follow_suggestions.dismiss": "फेरि नदेखाउनुहोस्",
  "follow_suggestions.hints.similar_to_recently_followed": "यो प्रोफाइल तपाईंले हालसालै फलो गर्नुभएका प्रोफाइलहरूसँग मिल्दोजुल्दो छ।",
  "follow_suggestions.popular_suggestion": "लोकप्रिय सुझाव",
  "follow_suggestions.popular_suggestion_longer": "{domain} मा लोकप्रिय",
  "follow_suggestions.similar_to_recently_followed_longer": "तपाईंले हालसालै फलो गर्नुभएको प्रोफाइलहरू जस्तै",
  "follow_suggestions.view_all": "सबै हेर्नुहोस्",
  "follow_suggestions.who_to_follow": "कसलाई फलो गर्ने",
  "followed_tags": "फलो गरिएका ह्यासट्यागहरू",
  "hashtag.follow": "ह्यासट्याग फलो गर्नुहोस्",
  "hashtag.unfollow": "ह्यासट्याग अनफलो गर्नुहोस्",
  "home.column_settings.show_reblogs": "बूस्टहरू देखाउनुहोस्",
  "ignore_notifications_modal.private_mentions_title": "अनावश्यक प्राइवेट उल्लेखहरूबाट आउने सूचनाहरूलाई बेवास्ता गर्न चाहनुहुन्छ?",
  "interaction_modal.no_account_yet": "अहिलेसम्म खाता छैन?",
  "keyboard_shortcuts.boost": "पोस्ट बुस्ट गर्नुहोस्",
  "keyboard_shortcuts.mention": "लेखकलाई उल्लेख गर्नुहोस्",
  "mute_modal.they_can_mention_and_follow": "\n\nतिनीहरूले तपाईंलाई उल्लेख गर्न र फलो गर्न सक्छन्, तर तपाईंले तिनीहरूलाई देख्नुहुने छैन।",
  "mute_modal.they_wont_know": "उनीहरूलाई म्यूट गरिएको बारे थाहा हुँदैन।",
  "mute_modal.title": "प्रयोगकर्तालाई म्युट गर्ने?",
  "mute_modal.you_wont_see_mentions": "तपाईंले तिनीहरूलाई उल्लेख गरिएका पोस्टहरू देख्नुहुने छैन।",
  "navigation_bar.blocks": "ब्लक गरिएको प्रयोगकर्ताहरु",
  "navigation_bar.direct": "प्राइवेट उल्लेखहरू",
  "navigation_bar.follow_requests": "फलो अनुरोधहरू",
  "navigation_bar.followed_tags": "फलो गरिएका ह्यासट्यागहरू",
  "navigation_bar.logout": "लग आउट",
  "notification.label.mention": "उल्लेख",
  "notification.label.private_mention": "प्राइवेट उल्लेख",
  "notification.mention": "उल्लेख",
  "notification.mentioned_you": "{name} ले तपाईंलाई उल्लेख गर्नुभयो",
  "notification.reblog": "{name} ले तपाईंको पोस्ट बूस्ट गर्नुभयो",
  "notification_requests.confirm_accept_multiple.title": "सूचना अनुरोधहरू स्वीकार गर्ने?",
  "notification_requests.confirm_dismiss_multiple.title": "सूचना अनुरोधहरू खारेज गर्ने?",
  "notifications.clear_title": "सूचनाहरू खाली गर्ने?",
  "notifications.column_settings.follow": "नयाँ फलोअरहरु:",
  "notifications.column_settings.follow_request": "नयाँ फलोअर अनुरोधहरु",
  "notifications.column_settings.mention": "उल्लेखहरू:",
  "notifications.column_settings.reblog": "बूस्टहरू:",
  "notifications.filter.boosts": "बूस्टहरू",
  "notifications.filter.mentions": "उल्लेखहरू",
  "notifications.policy.filter_private_mentions_title": "अनावश्यक प्राइवेट उल्लेखहरू",
  "onboarding.profile.note_hint": "तपाईं अन्य व्यक्तिहरूलाई @उल्लेख गर्न सक्नुहुन्छ वा #ह्यासट्यागहरू प्रयोग गर्न सक्नुहुन्छ…",
  "privacy.direct.long": "पोस्टमा उल्लेख गरिएका सबैजना",
  "privacy.direct.short": "प्राइवेट उल्लेख",
  "privacy.private.long": "मात्र तपाईंको फलोअरहरु",
  "privacy.private.short": "फलोअरहरु",
  "reply_indicator.cancel": "रद्द गर्नुहोस्",
  "report.comment.title": "के हामीले थाहा पाउनुपर्ने अरू केही छ जस्तो लाग्छ?",
  "report.forward_hint": "यो खाता अर्को सर्भरबाट हो। त्यहाँ पनि रिपोर्टको गुमनाम प्रतिलिपि पठाउने हो?",
  "report.rules.title": "कुन नियमहरू उल्लङ्घन भइरहेका छन्?",
  "report.statuses.title": "के यस रिपोर्टलाई समर्थन गर्ने कुनै पोस्टहरू छन्?",
  "report.thanks.title": "यो हेर्न चाहनुहुन्न?",
  "report.unfollow": "@{name} लाई अनफलो गर्नुहोस्",
  "search_results.hashtags": "ह्यासट्यागहरू",
  "sign_in_banner.sign_in": "लगइन",
  "sign_in_banner.sso_redirect": "लगइन वा दर्ता गर्नुहोस्",
  "status.cancel_reblog_private": "अनबुस्ट गर्नुहोस्",
  "status.cannot_reblog": "यो पोस्टलाई बुस्ट गर्न सकिँदैन",
  "status.direct": "@{name} लाई प्राइवेट रूपमा उल्लेख गर्नुहोस्",
  "status.direct_indicator": "प्राइवेट उल्लेख",
  "status.mention": "@{name} लाई उल्लेख गर्नुहोस्",
  "status.mute": "@{name}लाई म्यूट गर्नुहोस्",
  "status.mute_conversation": "कुराकानी म्यूट गर्नुहोस्",
  "status.reblog": "बूस्ट गर्नुहोस्",
  "status.reblogged_by": "{name} ले बूस्ट गर्नुभएको",
  "status.reblogs.empty": "यो पोस्टलाई अहिलेसम्म कसैले पनि बूस्ट गरेको छैन। कसैले बूस्ट गरेमा तिनीहरू यहाँ देखिनेछन्।",
  "status.unmute_conversation": "कुराकानी अनम्यूट गर्नुहोस्",
  "visibility_modal.quote_followers": "फलोअरहरु मात्र"
}
